<template>
  <Modal v-model="deliveryLocationModal" :title="deliveryLocationTitle" width="600"
    :transfer="false" :mask-closable="false" @on-visible-change="deliveryLocationChange">
    <Form ref="deliveryLocationForm" :model="deliveryLocationForm" :rules="ruleValidate" :label-width="120" @submit.native.prevent>
      <Row type="flex" style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002303')" prop="deliveryPlaceName">
            <Input clearable v-model.trim="deliveryLocationForm.deliveryPlaceName" :maxlength="20"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002304')" class="required_style_label" prop="deliveryCountries">
            <vueTreeSelect
              :clearable="true"
              :searchable="true"
              :multiple="true"
              :noResultsText="$t('key1000102')"
              :noOptionsText="$t('key1000375')"
              :placeholder="$t('key1000101')"
              :normalizer="setNormalizer"
              :options="shippingCountryData"
              v-model="deliveryLocationForm.deliveryCountries"
              @input="clearCountryCodesValidate"
              :defaultExpandLevel="0"/>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002305')" prop="allowCollectGoods" class="radio_styles">
            <RadioGroup v-model="deliveryLocationForm.allowCollectGoods">
              <Radio :label="1">{{ $t('key1000392') }}</Radio>
              <Radio :label="0">{{ $t('key1000393') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="deliveryLocationModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="deliveryLocationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import vueTreeSelect from "@riophae/vue-treeselect";
import {getNationalContinentName} from "@/utils/common";

export default {
  name: 'deliveryLocationModal',
  mixins: [Mixin],
  props: {
    shippingCountryData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      deliveryLocationModal: false,
      deliveryLocationTitle: '',
      deliveryLocationType: 'add',
      deliveryLocationForm: {
        deliveryPlaceName: '',
        deliveryCountries: [],
        allowCollectGoods: 1
      },
      ruleValidate: {
        deliveryPlaceName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002301'), trigger: 'blur'}
        ],
        deliveryCountries: [
          {required: true, type: 'array', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002302'), trigger: 'change'}
        ]
      },
      setNormalizer(node) {
        return {
          id: node.twoCode,
          label: node.title,
          children: node.children
        };
      },
      continentCodeList: [],
    };
  },
  methods: {
    // 初始化数据
    initDeliveryLocationData(type, obj) {
      let title = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002185'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184')
      };
      this.deliveryLocationType = type;
      this.deliveryLocationTitle = title[type];
      this.continentCodeList = this.shippingCountryData.map((item) => {
        return item.twoCode;
      });
      if (type === 'edit') {
        let ymsDeliveryPlaceCountryList = obj.ymsDeliveryPlaceCountryList || [];
        let countryCodes = ymsDeliveryPlaceCountryList.map((item) => item.deliveryCountry);
        let deliveryCountries = getNationalContinentName(countryCodes, this.shippingCountryData, 'code');
        this.deliveryLocationForm.deliveryCountries = deliveryCountries;
        let {deliveryPlaceName, allowCollectGoods, ymsDeliveryPlaceId} = obj;
        this.deliveryLocationForm.deliveryPlaceName = deliveryPlaceName;
        this.deliveryLocationForm.allowCollectGoods = allowCollectGoods;
        this.deliveryLocationForm.ymsDeliveryPlaceId = ymsDeliveryPlaceId;
      } else {
        this.$nextTick(() => {
          this.$refs['deliveryLocationForm'].resetFields();
        });
      }
      this.deliveryLocationModal = true;
    },
    // 确定
    deliveryLocationBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      let countryCodes = [];
      let deliveryCountries = v.deliveryLocationForm.deliveryCountries || [];
      deliveryCountries.map((value) => {
        v.shippingCountryData.map((item) => {
          if (value === item.twoCode) {
            let list = item.children.map((k) => {
              return k.twoCode;
            });
            countryCodes.push(...list);
          } else {
            if (!this.continentCodeList.includes(value)) {
              countryCodes.push(value);
            }
          }
        });
      });
      let countryCodesList = this.uniqueFunc(countryCodes);
      let obj = {
        deliveryPlaceName: v.deliveryLocationForm.deliveryPlaceName,
        deliveryCountries: countryCodesList,
        allowCollectGoods: v.deliveryLocationForm.allowCollectGoods
      };
      // 新增
      if (v.deliveryLocationType === 'add') {
        url = api.post_ymsDeliveryPlace_insertDeliveryPlace;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456');
      }
      // 编辑
      else if (v.deliveryLocationType === 'edit') {
        url = api.put_ymsDeliveryPlace_updateDeliveryPlace;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        obj.ymsDeliveryPlaceId = v.deliveryLocationForm.ymsDeliveryPlaceId;
      }
      v.$refs['deliveryLocationForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.deliveryLocationModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    deliveryLocationChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['deliveryLocationForm'].resetFields();
        });
      }
    },
    // 手动更新指定的字段校验状态
    clearCountryCodesValidate(newVal) {
      if (newVal && newVal.length > 0) {
        this.$refs['deliveryLocationForm'].validateField('deliveryCountries', () => {
        });
      } else {
        this.$refs['deliveryLocationForm'].validateField('deliveryCountries');
      }
    }
  },
  components: {
    vueTreeSelect
  }
};
</script>

<style lang="less">

</style>
